export default {
  booking: {
    title: '預訂信息',
    bookingTitle: '預訂標題',
    seatType: '座位類型',
    attendanceDate: '參加日期',
    participationTime: '參加時間',
    trainModel: '車型',
    seatInfo: '座位',
    reservationCount: '預訂數量',
    viewDetail: '查看詳情',
    bookingRange: {
      oneMonth: '1個月內的預訂',
      threeMonths: '3個月內的預訂',
      sixMonths: '6個月內的預訂'
    },
    adultTicket: '成人票',
    childTicket: '兒童票',
    status: {
      paymentPending: '待付款',
      paid: '預訂中，請稍候',
      confirmed: '預訂成功，已出票',
      cancelPending: '取消中',
      cancelled: '已取消',
      refunded: '已退款',
      paymentExpired: '支付過期',
      completed: '已完成',
      confirmFailed: '確認失敗'
    }
  },
  bookingDetail: {
    title: '訂單詳情',
    travelInfo: '出行信息',
    digitalTicket: '電子票券',
    meetingPoint: '集合或兌換地點說明',
    beforeTrip: '行前須知',
    bookingAction: '訂單操作',
    cancelBooking: '取消訂單',
    cancelConfirmPolicy: '請確認取消政策：',
    cancelTip:
      '出票後如需取消訂單請在乘車時間1小時前操作，否則無法取消退款，請知悉。',
    sendToEmail: '發到郵箱',
    attendanceDate: '參加日期',
    customerName: '預約姓名',
    email: '郵箱',
    actualPayment: '實付金額',
    orderId: '訂單ID',
    orderCompletionTime: '訂單完成時間',
    digitalTicketValidPeriod: 'QR 碼僅限乘車當日有效',
    digitalTicketWaiting: '*訂單確認後，電子票券將在此處顯示',
    sending: '發送中...',
    sendToEmailSuccess: '發送成功，請去郵箱查收'
  }
};
